import { render, staticRenderFns } from "./ChangeSelfPickupPoint.vue?vue&type=template&id=491d78fb&"
import script from "./ChangeSelfPickupPoint.vue?vue&type=script&lang=js&"
export * from "./ChangeSelfPickupPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('491d78fb')) {
      api.createRecord('491d78fb', component.options)
    } else {
      api.reload('491d78fb', component.options)
    }
    module.hot.accept("./ChangeSelfPickupPoint.vue?vue&type=template&id=491d78fb&", function () {
      api.rerender('491d78fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/modules/orderlist-dialog/ChangeSelfPickupPoint.vue"
export default component.exports